module.exports = __webpack_public_path__ + "static/media/018.e208c2b2.jpg";